import React from 'react'

const Frontend = () => {
    return (
        <div className="skills_content">
            <h3 className="skills_title"><i class='bx bx-layout'></i>Frontend</h3>

            <div className="skills_list">
                <div className="skills_item"> JavaScript</div>
                <div className="skills_item"> TypeScript</div>
                <div className="skills_item"> Angular</div>
                <div className="skills_item"> RxJS</div>
                <div className="skills_item"> SCSS</div>
                <div className="skills_item"> Bootstrap</div>
            </div>
        </div>
    )
}

export default Frontend